// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OkUS","colMin":"styles_colMin__2-i06"};